module.exports = __webpack_public_path__ + "static/media/cq_visualizza_documento b.68bec030.svg";